/**
 * Rhythm in which the demand of an offer request comes up, comparable to a
 * standing order at a bank. Combined with the interval count it reads as
 * "every n weeks", "every n months" or "yearly". Once covers a single order and
 * therefore replaces a separate order type.
 */
export enum OfferRequestCallOffInterval {
	Once = 0,
	Weekly = 1,
	Monthly = 2,
	Yearly = 3,
}
